import React, { useState, useEffect } from 'react';
import {motion} from 'framer-motion';
import styled from 'styled-components';
import { ProjectData } from '../data/Projectdata';
import ProjectCard from './ProjectCard';

function ProjectsCont() {

  const [projects, setProjects] = useState([]);
  const [activeType, setActiveType] = useState("all"); 

  useEffect(() => {
    setProjects(ProjectData);
  }, []);

  const filterProjects = (tech) => {
    setActiveType(tech);//very good method of changing the class of the menu items for active class
    if(tech==="all") setProjects(ProjectData);
    else if(tech==="full") setProjects(()=> ProjectData.filter(project=> project.type.includes("fullStack") ) );//important function remember the method to do this .
    else if(tech==="react") setProjects(()=> ProjectData.filter(project=> project.type.includes("react") ) );//important function remember the method to do this .
    else if(tech==="native") setProjects(()=> ProjectData.filter(project=> project.type.includes("reactNative") ) );//important function remember the method to do this .
    else if(tech==="basic") setProjects(()=> ProjectData.filter(project=> project.type.includes("basic") ) );//important function remember the method to do this .

    // console.log(projects);

  }

  return (
    <ProjectWrapper>
      <p className='text-tertiary center' >Look around, you may find something interesting!</p>
      <div className="separator"></div>
      <List>
        <li className={`clickable ${activeType==='all'? 'active': '' }`} 
          onClick={(e) => filterProjects("all", e)} >All</li>

        <li className={`clickable ${activeType==='full'? 'active': '' }`} 
          onClick={(e) => filterProjects("full", e)} >Full stack</li>

        <li className={`clickable ${activeType==='react'? 'active': '' }`} 
          onClick={(e) => filterProjects("react", e)} >React JS</li>

        <li className={`clickable ${activeType==='native'? 'active': '' }`} 
          onClick={(e) => filterProjects("native", e)} >React Native</li>

        <li className={`clickable ${activeType==='basic'? 'active': '' }`} 
          onClick={(e) => filterProjects("basic", e)} >Basic</li>
      </List>

      {/* for filter animation */}
      {/* we also need to add the layout to the children also to animate this. warna streching issue aayega */}
      <motion.div layout className='proj-cont' >  
        {projects.map(proj => (
          <ProjectCard key={proj.name} data={proj} />
        ))}
      </motion.div>

    </ProjectWrapper>
  );
}

const ProjectWrapper = styled.div`
  background-color: var(--white);
  width: 100%;

  .separator{
    width: 70%;
    margin: 1rem auto 3rem auto ;
    border-bottom: 1px solid var(--tertiary);
  }
  .proj-cont{ 
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 3fr));
    grid-gap: 1rem;
    width: 70%;
    margin: 2rem auto;
  }

`
const List = styled.ul`
  display: flex;
  width: 40%;
  align-items: center;
  justify-content: space-around;
  margin: 2rem auto;

  li{
    list-style: none;
    color: var(--primary);
    font-family: "Raleway_m" sans-serif;
  }

  .active{
    text-decoration: line-through;
    color: var(--tertiary);
  }

  @media only screen and (max-width: 500px){
    width: 90%;
    justify-content: space-between;

    li{
      font-size: 0.8rem;
    }

  }
`

export default ProjectsCont;